import { Component, type ReactNode } from "react";
import i18n from "@/i18n";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="cx-login-bg flex h-full items-center justify-center">
          <div className="text-center px-6">
            <h1 className="cx-dialog-title text-[18px] font-medium mb-2">{i18n.t("error.title")}</h1>
            <p className="cx-text-secondary text-[14px] mb-4">{i18n.t("error.description")}</p>
            <button
              onClick={() => window.location.reload()}
              className="cx-login-submit px-4 py-2 text-[14px] font-medium"
            >
              {i18n.t("error.reload")}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
